/* eslint-disable no-underscore-dangle */
import PagingFeed from '../lib/PagingFeed';

class PagingOsImageServerFeed extends PagingFeed {
  _getFeed() {
    return this._EntityDef.startAscendOsImageServersFeed(
      this._activeOrgId,
      this._filter,
      this._entityFields,
      this._sort,
      {skip: 0, limit: 100}
    );
  }

  _getDistinctValuesOfField(tenantId, field) {
    return this._EntityDef.startOsImageServerDistinctValuesFeed(tenantId, field);
  }

  _getFeedIdsForSelection(tenantId, selection) {
    return this._EntityDef.loadOsImageServerIdsForSelection(tenantId, selection);
  }

  getOsImageServerEntitiesById(ids) {
    return this.getEntitiesById(ids);
  }

  getOsImageServerEntitiesNameById(ids) {
    return this.getEntitiesNameById(ids);
  }

  getOsImageServerEntityById(id) {
    return this.getEntityById(id);
  }
}

export default PagingOsImageServerFeed;
